import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { SET_IS_LOGOUT_IN_PROGRESS, SET_IS_SESSION_TIMED_OUT } from './logoutActions'

interface LogoutState extends Map<string, any> {
  isSessionTimedOut: boolean
  isLogoutInProgress: boolean
}

const initialState: LogoutState = fromJS({
  isSessionTimedOut: false,
  isLogoutInProgress: false,
})

export default createReducer(initialState, {
  [SET_IS_SESSION_TIMED_OUT]: ($$state: LogoutState, action: { value: boolean }) => {
    return $$state.set('isSessionTimedOut', action.value)
  },
  [SET_IS_LOGOUT_IN_PROGRESS]: ($$state: LogoutState, action: { value: boolean }) => {
    return $$state.set('isLogoutInProgress', action.value)
  },
})
